import React, { useState, useMemo, useEffect } from 'react';
import ThemeContext from './ThemeContext';
import PropTypes from 'prop-types';

function ThemeProvider({ children }) {
    const savedTheme = localStorage.getItem('theme');
    const [theme, setTheme] = useState(savedTheme || 'light');

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    };

    const initialState = useMemo(
        () => ({
            theme,
            setTheme,
            toggleTheme
        }),
        [theme],
    );

    useEffect(() => {
        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={initialState}>
            <div>{children}</div>
        </ThemeContext.Provider>
    );
}

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ThemeProvider;
